import { render } from "./ui-task-list-item.vue?vue&type=template&id=bdfde324&scoped=true"
import script from "./ui-task-list-item.vue?vue&type=script&lang=js"
export * from "./ui-task-list-item.vue?vue&type=script&lang=js"

import "./ui-task-list-item.vue?vue&type=style&index=0&id=bdfde324&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdfde324"]])

export default __exports__